<label [class]="classes">
  <input type="checkbox" class="netfone-checkbox" [formControl]="fc" [disabled]="fc.disabled" />
  <span class="check-toggle" [class]="{ disabled: fc.disabled }"></span>
  <ng-content></ng-content>
</label>
